import Skeleton from './Skeleton';
import CardSkeleton from './CardSkeleton';

/**
 * Full-page skeleton used as the Suspense fallback for lazy routes.
 * Mimics the typical page layout: header + 2-3 cards.
 */
const PageSkeleton = () => (
  <div className="skeleton-page">
    <div className="skeleton-page__header">
      <Skeleton height={22} width="35%" style={{ marginBottom: 8 }} />
      <Skeleton height={12} width="50%" />
    </div>
    <div className="skeleton-page__grid">
      <CardSkeleton titleWidth={45} lines={4} />
      <CardSkeleton titleWidth={55} lines={3} />
    </div>
  </div>
);

export default PageSkeleton;
